import React from 'react';
import DoutoOfferPanel from './DoutoOfferPanel';
import { useLocale } from '../LocaleProvider';

/**
 * Mostrado uma vez por retorno (login após 3+ dias sem acessar), fora do fluxo de
 * onboarding. Dispensável a qualquer momento; não bloqueia o dashboard por trás.
 */
export default function DoutoReengagementPopup({ name, email, onClose }) {
  const { locale } = useLocale();
  const es = locale === 'es';
  return (
    <div className="fixed inset-0 z-[90] flex min-h-dvh items-start justify-center overflow-y-auto bg-[rgba(36,64,47,0.55)] p-4 sm:items-center sm:p-6" role="dialog" aria-modal="true" aria-labelledby="douto-reengage-title">
      <div className="relative my-auto max-h-[calc(100dvh-2rem)] w-full max-w-lg overflow-hidden rounded-[var(--radius-block)] bg-[var(--surface)] sm:max-h-[calc(100dvh-3rem)]">
        <header className="band-forest px-6 py-6 sm:px-7">
          <button type="button" aria-label={es ? 'Cerrar' : 'Fechar'} onClick={onClose} className="absolute right-5 top-5 text-2xl leading-none text-[var(--on-forest-2)]">×</button>
          <span aria-hidden="true" className="eyebrow-rule mb-2" />
          <p className="eyebrow text-sm text-[var(--on-forest-2)]">{es ? 'Tu descuento sigue reservado' : 'Seu desconto continua reservado'}</p>
          <h2 id="douto-reengage-title" className="mt-1 text-xl">{es ? 'Mientras no estabas' : 'Enquanto você esteve fora'}</h2>
        </header>
        <div className="overflow-y-auto p-6 sm:p-7" style={{ maxHeight: 'calc(100dvh - 12rem)' }}>
          <DoutoOfferPanel context="reengagement" name={name} email={email} onLinkClick={onClose} />
        </div>
      </div>
    </div>
  );
}
